export default "__VITE_ASSET__CnSPnN1z__"